

import { axiosArmadoV2 } from "../app/modules/Sales/_redux/orders/ordersCrud";

export default function setupAxios(axios, store) {

  const attachToken = config => {
    const {
      auth: { authToken }
    } = store.getState();

    if (authToken) {
      config.headers.Authorization = authToken // `Bearer ${authToken}`;
    }

    return config;
  };

  axios.interceptors.request.use(attachToken, err => Promise.reject(err));

  // Instancia dedicada del armado V2: mismo token, pero SIN el interceptor global
  // de respuestas (Aside.js) que resuelve los errores como undefined
  axiosArmadoV2.interceptors.request.use(attachToken, err => Promise.reject(err));

}
